/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetCustomerChargebackSummaryRequest} from '@cash-web/protos/squareup/cash/payback/api/Service.pb'
import {GetCustomerChargebackSummaryResponse} from '@cash-web/protos/squareup/cash/payback/api/Service.pb'


export const getCustomerChargebackSummary = (request: GetCustomerChargebackSummaryRequest, options?: CashRequestOptions) => post<GetCustomerChargebackSummaryRequest, GetCustomerChargebackSummaryResponse>("/2.0/cash/get-customer-chargeback-summary", request, {...options, rejectOnError: true })